<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <div [formGroup]="getControl('data')">
    <section class="container">
      <div></div>
      <p>
        Please use the fields below to tell us about this newborn. If the mother
        gave birth to more than one newborn, complete this page first.
      </p>
      <p>
        If you need to tell us about a Safe Haven Baby, you must use the Birth
        Reporting Form and fax or mail the form to TennCare Connect.
        <a
          class="page-info btn-link"
          href="https://www.tn.gov/content/dam/tn/tenncare/documents/BirthReportingFormEng.pdf"
          target="_blank"
          title="Click here"
          aria-label="Click here"
          aria-describedby="birth-form-desc-newborn"
          >Click here</a
        >
        to download the Birth Reporting Form for a Safe Haven Baby.
      </p>
      <br />
      <h1 class="section-header">Newborn</h1>
      <hr />
      <form [formGroup]="newBornInformation">
        <div class="row g-3">
          <div class="col-8 col-lg-4">
            <nh-field
              [attr.aria-required]="true"
              id="nein_childFirstName"
              label="Baby's First Name"
              isRow="true"
              [mandatory]="true"
              class="label-section"
            >
              <input
                type="text"
                name="childFirstName"
                aria-label="Baby's First Name'"
                formControlName="childFirstName"
                maxlength="45"
                required
              />
            </nh-field>
          </div>
          <div class="col-8 col-lg-4">
            <nh-field
              [attr.aria-required]="false"
              id="nein_childMidName"
              label="Baby's Middle Initial"
              isRow="true"
              [mandatory]="false"
              class="label-section"
            >
              <input
                type="text"
                name="childMidName"
                aria-label="Baby's Middle Initial"
                maxlength="1"
                formControlName="childMidName"
              />
            </nh-field>
          </div>
          <div class="col-8 col-lg-4">
            <nh-field
              [attr.aria-required]="true"
              id="nein_childLastName"
              label="Baby's Last Name"
              isRow="true"
              [mandatory]="true"
              class="label-section"
            >
              <input
                maxlength="21"
                type="text"
                aria-label="Baby's Last Name"
                name="childLastName"
                formControlName="childLastName"
                required
              />
            </nh-field>
          </div>
        </div>
        <nh-field
          [attr.aria-required]="true"
          id="nein_childDob"
          aria-label="Baby's Date of Birth"
          label="Baby's Date of Birth"
          [mandatory]="true"
          class="label-section"
        >
          <nh-datepicker>
            <input
              type="text"
              name="childDob"
              formControlName="childDob"
              [minDate]="minimumDate"
              (change)="isInvalidDate($event)"
              [maxDate]="today"
              bsDatepicker
              nh
              required
              aria-label="Baby's Date of Birth"
            />
          </nh-datepicker>
        </nh-field>

        <div class="row g-3">
          <div class="col-6 col-md-6">
            <nh-field
              [attr.aria-required]="true"
              id="nein_genderCd"
              label="Baby's Gender"
              [mandatory]="true"
              class="label-section"
            >
              <select
                nh
                name="genderCd"
                aria-label="Baby's Gender"
                [items]="tables.GENDER"
                formControlName="genderCd"
                required
              >
              </select>
            </nh-field>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-6 col-md-6">
            <nh-field
              [attr.aria-required]="true"
              id="nein_childDeceasedSw"
              label="Is this baby deceased?"
              [mandatory]="true"
              class="label-section"
            >
              <select
                nh
                name="childDeceasedSw"
                aria-label="Is this baby deceased?"
                [items]="tables.YESNO"
                formControlName="childDeceasedSw"
                required
              >
              </select>
            </nh-field>
          </div>
        </div>
        @if (isEnabled('data.childDeathDt')) {
        <nh-field
          [attr.aria-required]="true"
          id="nein_childDeathDt"
          aria-label="Date of Death"
          label="Date of Death"
          [mandatory]="true"
          class="label-section"
        >
          <nh-datepicker>
            <input
              type="text"
              name="childDeathDt"
              formControlName="childDeathDt"
              (change)="isInvalidDate($event)"
              [minDate]="minimumDate"
              [maxDate]="today"
              bsDatepicker
              nh
              required
              aria-label="Date of Death"
            />
          </nh-datepicker>
        </nh-field>
        }

        <div class="row g-3">
          <div class="col-6 col-md-6">
            <nh-field
              [attr.aria-required]="false"
              id="nein_ssn"
              label="Social Security Number"
              [mandatory]="false"
              class="label-section"
            >
              <nh-popover
                role="tooltip"
                field-label
                class="ml-2 ps-1"
                [content]="caseheadPopoverText"
              ></nh-popover>
              <input
                type="text"
                name="ssn"
                aria-label="Social Security Number"
                formControlName="ssn"
                placeholder="XXX-XX-XXXX"
                mask="000-00-0000"
                (blur)="compareSSN()"
              />
            </nh-field>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-6 col-md-6">
            <nh-field
              [attr.aria-required]="false"
              id="nein_ssnConfirm"
              [mandatory]="false"
              label="{{ 'CONFIRM_SSN' | translate }}"
              class="label-section"
            >
              <input
                [attr.aria-label]="'CONFIRM_SSN' | translate"
                type="text"
                name="ssnConfirm"
                formControlName="ssnConfirm"
                placeholder="XXX-XX-XXXX"
                mask="000-00-0000"
                (blur)="compareSSN()"
              />
            </nh-field>
          </div>
        </div>
        <nh-alert
          type="warning"
          [isOpen]="getControl('data.ssn').touched && isEmpty('data.ssn')"
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
                aria-hidden="true"
              />
            </div>
            <div class="col message">
              <span> {{ "SOCIAL_SECURITY_STATIC_TEXT4" | translate }} </span>
            </div>
          </div>
        </nh-alert>
        <nh-field
          [attr.aria-required]="true"
          id="nein_facilityBirthSw"
          label="Was this baby born in your facility?"
          [mandatory]="true"
          class="label-section"
        >
          <select
            nh
            name="facilityBirthSw"
            [items]="tables.YESNO"
            aria-label="Was this baby born in your facility?"
            formControlName="facilityBirthSw"
            required
          >
          </select>
        </nh-field>
        @if (isN('data.facilityBirthSw')) {
        <nh-field
          [attr.aria-required]="true"
          id="nein_usCtznSw"
          label="Is {{ this.name }} a United States citizen?"
          [mandatory]="true"
          class="label-section"
        >
          <select
            nh
            name="usCtznSw"
            [items]="tables.YESNO"
            formControlName="usCtznSw"
            [attr.aria-label]="'Is ' + this.name + ' a United States citizen?'"
            required
          >
          </select>
        </nh-field>
        } @if (isN('data.facilityBirthSw') && isY('data.usCtznSw')) {
        <nh-field
          [attr.aria-required]="true"
          id="nein_derivedCtznSw"
          label="Is {{ this.name }} a naturalized or derived U.S citizen?"
          [mandatory]="true"
          class="label-section"
        >
          <P>This usually means that they were born outside of the U.S.</P>
          <select
            nh
            name="derivedCtznSw"
            [attr.aria-label]="
              'Is ' + this.name + ' a naturalized or derived U.S citizen?'
            "
            [items]="tables.YESNO"
            formControlName="derivedCtznSw"
            required
          >
          </select>
        </nh-field>
        } @if (isalienAndNatureNumberEnable) {
        <div class="row g-3">
          <div class="col-6 col-md-6">
            <nh-field
              [attr.aria-required]="false"
              id="nein_alienNum"
              aria-label="Alien Number"
              label="Alien Number"
              [mandatory]="false"
              class="label-section"
            >
              <input
                type="text"
                name="alienNum"
                formControlName="alienNum"
                nh
                aria-label="Alien Number"
              />
            </nh-field>
          </div>
        </div>
        } @if (isalienAndNatureNumberEnable) {
        <div class="row g-3">
          <div class="col-7 col-md-7">
            @if (isalienAndNatureNumberEnable) {
            <nh-field
              [attr.aria-required]="false"
              id="nein_naturalCertNum"
              aria-label="Naturalization Certificate Number"
              label="Naturalization Certificate Number"
              [mandatory]="false"
              class="label-section"
            >
              <input
                type="text"
                name="naturalCertNum"
                formControlName="naturalCertNum"
                nh
                aria-label="Naturalization Certificate Number"
              />
            </nh-field>
            }
          </div>
        </div>
        }
      </form>
    </section>
  </div>
</nh-form>
